'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail(email, error) {
  this.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_email = null;
  this.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_error = null;
  this.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_email = email;
  this.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_error = error;
}
export { $c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail as $c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail };
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.constructor = $c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail;
/** @constructor */
function $h_Lapp_auth_ClientSideAuthFailure$UnparseableEmail() {
}
export { $h_Lapp_auth_ClientSideAuthFailure$UnparseableEmail as $h_Lapp_auth_ClientSideAuthFailure$UnparseableEmail };
$h_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype = $c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype;
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, (-1459318151), true);
});
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail) && ((this.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_email === x$0.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_email) && (this.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_error === x$0.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_error))));
});
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.productPrefix__T = (function() {
  return "UnparseableEmail";
});
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_email;
  }
  if ((n === 1)) {
    return this.Lapp_auth_ClientSideAuthFailure$UnparseableEmail__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "email";
  }
  if ((n === 1)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_auth_ClientSideAuthFailure$UnparseableEmail(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_auth_ClientSideAuthFailure$UnparseableEmail)));
}
export { $isArrayOf_Lapp_auth_ClientSideAuthFailure$UnparseableEmail as $isArrayOf_Lapp_auth_ClientSideAuthFailure$UnparseableEmail };
var $d_Lapp_auth_ClientSideAuthFailure$UnparseableEmail = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_auth_ClientSideAuthFailure$UnparseableEmail, "app.auth.ClientSideAuthFailure$UnparseableEmail", ({
  Lapp_auth_ClientSideAuthFailure$UnparseableEmail: 1,
  Lapp_auth_ClientSideAuthFailure: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_auth_ClientSideAuthFailure$UnparseableEmail as $d_Lapp_auth_ClientSideAuthFailure$UnparseableEmail };
//# sourceMappingURL=app.auth.-Client-Side-Auth-Failure$-Unparseable-Email.js.map
